import React, { Component, PropTypes } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import nl2br from 'react-nl2br';
import { emojify } from 'react-emojione';

import quantity from 'quantity';
import { CommentShape } from 'entities';
import Comment from 'components/CommentsList/Comment';
import { getCommentsById } from 'selectors';
import ResourceCommentsPageSelector from '../../ResourceCommentsPageSelector';
import ResourceCommentsTextEditor from '../../ResourceCommentsTextEditor';
import * as actions from 'actions';

class ResourceComment extends Component {

  constructor() {
    super();

    this.handleMarkAsUseful = this.handleMarkAsUseful.bind(this);
    this.handleUnmarkAsUseful = this.handleUnmarkAsUseful.bind(this);
  }

  shouldComponentUpdate(nextProps) {
    // we only care about this comment, otherwise commentsById prop will make it update on changes in any other comment
    return this.props.comment != nextProps.comment || this.props.isFetchingReplies != nextProps.isFetchingReplies;
  }

  renderLoadingReplies() {
    return [
      <Comment key="loader1" isEmpty />,
      <Comment key="loader2" isEmpty />,
      <Comment key="loader3" isEmpty />
    ];
  }

  handleMarkAsUseful(commentId) {
    this.props.onMarkAsUseful && this.props.onMarkAsUseful(this.props.commentsById[commentId]);
  }

  handleUnmarkAsUseful(commentId) {
    this.props.onUnmarkAsUseful && this.props.onUnmarkAsUseful(this.props.commentsById[commentId]);
  }

  renderComment(comment, parentCommentId, commentsById, canBeRepliedTo) {
    const repliesIds = comment.replies;
    let replies = null;

    if(repliesIds) {
      replies = repliesIds.map(replyId => commentsById[replyId]);
    }

    let ref = null;

    if(this.props.commentOrReplyRef && this.props.commentOrReplyId === comment.id) {
      ref = value => this.props.commentOrReplyRef(value);
    }

    return (
      <Comment
        isRoot={parentCommentId === null}
        key={comment.id}
        isHighlighted={comment.isHighlighted}
        ref={ref}
        commentId={comment.id}
        canBeRepliedTo={canBeRepliedTo}
        text={nl2br(emojify(comment.text, {output: 'unicode'}))}
        authorName={comment.author.userName}
        authorAvatar={comment.author.avatar.url}
        since={moment(comment.createdAt).fromNow()}
        repliesInfo={`${comment.replyCount} ${quantity(comment.replyCount, __('entities.replies.singular'), __('entities.replies.plural'))}`}
        canViewReplies={comment.replyCount > 0}
        isMarkedAsUseful={comment.useful}
        canBeMarkedAsUseful={parentCommentId === null}
        onViewReplies={this.props.onViewReplies}
        onHideReplies={this.props.onHideReplies}
        onReply={this.props.onReply}
        onCancelReply={this.props.onCancelReply}
        onMarkAsUseful={this.handleMarkAsUseful}
        onUnmarkAsUseful={this.handleUnmarkAsUseful}>

          {(() => {
            // Replies are not cached by page so we reload them each time.
            if(this.props.isFetchingReplies) {
              return this.renderLoadingReplies();
            }
            else if(replies) {
              return replies.map(reply => this.renderComment(reply, comment.id, commentsById, false));
            }
          })()}

      </Comment>
    );
  }

  render() {
    const { comment, commentsById, repliesPagesCount, canBeRepliedTo } = this.props;

    return (
      <div className="ResourceComment">
        {this.renderComment(comment, null, commentsById, canBeRepliedTo)}

        {comment.isBeingRepliedTo && <ResourceCommentsTextEditor resourceType={this.props.repliesResourceType} resourceId={comment.id} isExpanded shouldFocusOnMountAndUpdate />}

        {repliesPagesCount > 1 && comment.replies &&
          <div className="pagination-wrapper-inner">
            <ResourceCommentsPageSelector
              pageSize={process.env.KOOTH_COMMENT_REPLIES_PAGE_SIZE}
              resourceType={this.props.repliesResourceType}
              resourceId={comment.id} />
          </div>
        }
      </div>
    );
  }
}

ResourceComment.propTypes = {
  comment: CommentShape,
  repliesResourceType: PropTypes.string,
  commentReplyingId: PropTypes.number,
  repliesPagesCount: PropTypes.number,
  commentsById: PropTypes.object,
  isFetchingReplies: PropTypes.bool,
  commentOrReplyRef: PropTypes.func,
  commentOrReplyId: PropTypes.number,
  canBeRepliedTo: PropTypes.bool,
  onViewReplies: PropTypes.func,
  onHideReplies: PropTypes.func,
  onReply: PropTypes.func,
  onCancelReply: PropTypes.func,
  onMarkAsUseful: PropTypes.func,
  onUnmarkAsUseful: PropTypes.func
};

const mapStateToProps = state => {

	return {
    commentsById: getCommentsById(state)
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    onViewReplies: commentId => {
      const query = {resourceId: commentId, resourceType: props.repliesResourceType};

      dispatch(actions.commentsFetch(1, process.env.KOOTH_COMMENT_REPLIES_PAGE_SIZE, query));
    },
    onHideReplies: commentId => {
      dispatch(actions.commentUpdate(commentId, null, {replies: null}));
    },
    onReply: commentId => {
      dispatch(actions.commentReplyBegin(commentId));
    },
    onCancelReply: () => {
      dispatch(actions.commentReplyCancel());
    },
    onMarkAsUseful: comment => {
      dispatch(actions.commentUpdate(comment.id, comment, {useful: true}));
    },
    onUnmarkAsUseful: comment => {
      dispatch(actions.commentUpdate(comment.id, comment, {useful: false}));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ResourceComment);



/** WEBPACK FOOTER **
 ** ./src/members/Main/__shared__/containers/ResourceCommentsList/ResourceComment/index.js
 **/